export { BioEntitiesPinsListItem } from './BioEntitiesPinsListItem.component';
